import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider, ThemeProviderProps } from '@material-ui/styles';
import React from 'react';
import { theme as jupiterTheme } from '../theme';

interface Props {
  children: JSX.Element;
  theme?: ThemeProviderProps['theme'];
}

const ThemeWrap = ({ children, theme }: Props) => (
  <ThemeProvider theme={theme || jupiterTheme}>
    <CssBaseline />
    {children}
  </ThemeProvider>
);

export default ThemeWrap;
